import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

/**
 * Public route wrapper that redirects authenticated users
 */
const PublicRoute = ({ children }) => {
  const { isAuthenticated, isSuperAdmin, user } = useAuth();

  if (isAuthenticated) {
    const target = user?.role === 'Customer' ? '/customer-portal' : isSuperAdmin ? '/super-admin' : '/dashboard';
    return <Navigate to={target} replace />;
  }

  return children;
};

export default PublicRoute;
